import Streams from './streams';

export default ($axios) => ({
  streams: Streams($axios),
  fetch(query) {
    return $axios.get('/flow/flows', { params: query }).then((response) => response.data);
  },
});
